export enum MediaType {
  SMALL_SCREEN = 'SMALL_SCREEN',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  LAPTOP = 'LAPTOP',
  DESKTOP = 'DESKTOP',
  LARGE_SCREEN = 'LARGE_SCREEN',
}
